import { useEffect, useState } from 'react';

import { fetchSpaces } from '~services/api.helpers';

const useSpaces = organizationId => {
  const [loading, setLoading] = useState(true);
  const [spaces, setSpaces] = useState([]);

  useEffect(() => {
    const update = async () => {
      const spaces = await fetchSpaces(organizationId);
      setSpaces(spaces);
      setLoading(false);
    };

    update();
  }, []);

  return { spaces, loading };
};

export default useSpaces;
